import { React, useState } from "react";
import { Box } from "@mui/material";
import Header from "components/Header";
import MaterialReactTable from "material-react-table";
import {
  useGetCountriesQuery,
  useGetUserQuery,
  useEditIdTypeMutation,
  useEditDeliveryChannelMutation,
} from "state/api";
import { useAuth } from "../../contexts/AuthContext";

const DeliveryChannel = () => {
  const { user, isLoading: isUserLoading, refetch } = useAuth();
  // edit deliveryType mutation
  const [editDeliveryChannel, { isLoading, isError }] =
    useEditDeliveryChannelMutation();
  console.log(user);
  const handleSave = async ({ values, table, row, exitEditingMode }) => {
    console.log(values);
    console.log(row.original); //exit editing mode
    try {
      await editDeliveryChannel({ ...row.original, ...values });
      await refetch(); // Refresh user data to show updated values
      exitEditingMode();
    } catch (error) {
      console.error("Failed to save changes:", error);
    }
  };

  const columns = [
    {
      accessorKey: "description",
      header: "Risk",
      enableEditing: false,
    },
    {
      accessorKey: "Score",
      header: "Risk Score",
      type: "number", // Specify the type for proper input handling
      Cell: ({ cell }) => cell.getValue(),
      // Enable editing for this column
      enableEditing: true,
      editVariant: "select",
      editSelectOptions: [1, 2, 3, 4],
    },
  ];

  if (isLoading || isUserLoading || !user) {
    return <div>Loading...</div>;
  }

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="Delivery Channel Risk"
        subtitle="RBA Definition Delivery Channel"
      />
      <Box sx={{ height: 400, width: "100%" }}>
        <MaterialReactTable
          columns={columns}
          data={user.deliveryChannel || []}
          enableEditing
          editingMode="row"
          onEditingRowSave={handleSave}
        />
      </Box>
    </Box>
  );
};

export default DeliveryChannel;
